import React from 'react';
import './App.css';
import Course from './Course';
import TakenCourse from './TakenCourse';

class CourseArea extends React.Component {
  getCourses() {
    let courses = [];
    if (this.props.isTaken) {
      if (Array.isArray(this.props.completedCourses)) {
        for (let i = 0; i < this.props.completedCourses.length; i++) {
          courses.push(
            <TakenCourse
              key={'taken' + this.props.completedCourses[i].number}
              courseKey={this.props.completedCourses[i].number}
              rate={(course) => this.props.rate(course)}
              data={this.props.completedCourses[i]}
            />
          )
        }
      }
      else {
        for (const course of Object.keys(this.props.completedCourses)) {
          courses.push(
            <TakenCourse
              key={'taken' + this.props.completedCourses[course].number}
              courseKey={this.props.completedCourses[course].number}
              rate={(course) => this.props.rate(course)}
              data={this.props.completedCourses[course]}
               />
          )
        }
      }
    } else {
      if (Array.isArray(this.props.data)) {
        for (let i = 0; i < this.props.data.length; i++) {
          courses.push(
            <Course
              key={this.props.data[i].number}
              data={this.props.data[i]}
              courseKey={this.props.data[i].number}
              addCartCourse={(data) => this.props.addCartCourse(data)}
              removeCartCourse={(data) => this.props.removeCartCourse(data)}
              cartCourses={this.props.cartCourses}
              completedCourses={this.props.completedCourses}
            />
          )
        }
      }
      else {
        for (const course of Object.keys(this.props.data)) {
          courses.push(
            <Course
              key={this.props.data[course].number}
              data={this.props.data[course]}
              courseKey={this.props.data[course].number}
              addCartCourse={(data) => this.props.addCartCourse(data)}
              removeCartCourse={(data) => this.props.removeCartCourse(data)}
              cartCourses={this.props.cartCourses}
              completedCourses={this.props.completedCourses} />
          )
        }
      }
    }
    if (courses.length == 0) return (<h2 style={{ fontWeight: 'bolder' }}>Error 404: No courses found.</h2>);
    return courses;
  }

  shouldComponentUpdate(nextProps) {
    return (JSON.stringify(this.props) !== JSON.stringify(nextProps))
  }

  render() {
    return (
      <div style={{ margin: 5, marginTop: -5 }}>
        {this.getCourses()}
      </div>
    )
  }
}

export default CourseArea;
